import type { FC } from 'react';

import styles from './ComponentsCount.module.scss';

type Props = {
  count: number;
};

export const ComponentsCount: FC<Props> = ({ count }) => {
  const label = count === 1 ? '1 component' : `${count} components`;

  return <span className={styles.count}>{label}</span>;
};
